import type { MetricsExportRequestFormat } from './metricsExportRequestFormat';

export interface MetricsExportRequest {
  endDate: string;
  format: MetricsExportRequestFormat;
  startDate: string;
  types?: string[];
}
